export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-medium-854fcaa1655f2465c760ac55054faafb.ttf";